/// <amd-dependency path='VSS/LoaderPlugins/Css!TestManagement' />

import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import * as RunWithDTRDialog from "TestManagement/Scripts/Scenarios/RunWithDTRDialog/Components/RunWithDTRDialog";

export interface RunWithDTRProxyProps {
    onLaunch: () => void;
}

// This is a proxy component to load the assign configuration dialog in the new web platform using LegacyComponent
class RunWithDTRProxy extends React.Component<RunWithDTRProxyProps, {}> {
    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        let container = document.createElement("div");
        let dtrProps: RunWithDTRDialog.IRunWithDTRDialogProps = {
            dtrCallBack: this.props.onLaunch
        };
        RunWithDTRDialog.renderDialog(container, dtrProps);
    }
}

registerLWPComponent("run-dtr-proxy", RunWithDTRProxy);
